"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isModelSimple = void 0;
var IOptions_1 = require("./WrappedProperty/IOptions");
var WrappedProperty_1 = require("./WrappedProperty");
var fixAndMergeSchema_1 = require("./JSchema/fixAndMergeSchema");
var defaultValue_1 = require("./JSchema/defaultValue");
var fixData_1 = require("./JSchema/fixData");
/**
 * czy to jest prosty model
 *
 * @export
 * @param {*} model model wejściowy
 * @param {number} [maxPropCount=100] maksymalna dopuszczalna liczba wlasciwości
 * @param {IRefCount} [refCount] informacje wewnętrzne
 * @returns {boolean} czy liczba włąsciwości nie przekaracza max
 */
function isModelSimple(model, maxPropCount, refCount) {
    if (maxPropCount === void 0) { maxPropCount = 100; }
    refCount = refCount || { count: 0 };
    if (model === undefined) {
        return false;
    }
    if (Array.isArray(model)) {
        refCount.count += model.length;
        if (refCount.count > maxPropCount)
            return false;
        for (var _i = 0, model_1 = model; _i < model_1.length; _i++) {
            var item = model_1[_i];
            if (!isModelSimple(item, maxPropCount, refCount)) {
                return false;
            }
        }
    }
    else if (typeof model === 'object' && model) {
        for (var key in model) {
            if (!isModelSimple(model[key], maxPropCount, refCount)) {
                return false;
            }
        }
    }
    else {
        if (++refCount.count > maxPropCount)
            return false;
    }
    return true;
}
exports.isModelSimple = isModelSimple;
var schemaMixin = {
    beforeCreate: function () {
        var vm = this;
        // constructor
        var Vue = vm.constructor;
        while (Vue.super) {
            Vue = Vue.super;
        }
        if (Vue.Renderless) {
            Vue = Vue.Renderless;
        }
        vm.$VueConstructor = Vue;
        vm.$methods = Vue.prototype.$methods = IOptions_1.defaultOptions.schemaMethods;
    },
    created: function () {
        var vm = this;
        var schema = vm.$options.schema;
        if (schema && vm.$setSchema) {
            vm.$setSchema(schema, false);
        }
    },
    beforeDestroy: function () {
        this.$setSchema();
    },
    methods: {
        $setSchema: function (schema, forceUpdate) {
            var vm = this;
            if (vm.$schema) {
                vm.$schema.$destroy();
            }
            vm.$schema = undefined;
            if (!schema) {
                return undefined;
            }
            if (vm.model === undefined) {
                throw new Error('no `model` property in data');
            }
            var soptions = IOptions_1.fixSchemaOptions();
            soptions.Vue = vm.$VueConstructor;
            soptions.disabledFields = {};
            // if (vm.ext)
            if (vm.$options.external) {
                soptions.external = vm.$external = vm.$options.external;
            }
            vm.$form = soptions.form = vm.form || {};
            var schema2 = null;
            if (process.env.NODE_ENV === 'development') {
                // tslint:disable-next-line: no-console
                console.time('schema fixing time');
            }
            var sopts = vm.schemaOptions || vm.$options.schemaOptions;
            var fixOptions = Object.assign({}, fixAndMergeSchema_1.fixSchemaDefaultOptions);
            if (sopts && sopts.arrayItemGuidField !== undefined) {
                fixOptions.arrayItemGuidField = sopts.arrayItemGuidField;
            }
            else {
                if (schema.$options && schema.$options.arrayItemGuidField !== undefined) {
                    fixOptions.arrayItemGuidField = schema.$options.arrayItemGuidField;
                }
            }
            fixOptions.model = vm.model;
            if (!Array.isArray(schema)) {
                schema = [schema];
            }
            else {
                schema = schema.slice(0);
            }
            if (vm.$options.beforeFixSchema) {
                vm.$options.beforeFixSchema.call(vm, schema, fixOptions);
            }
            schema2 = fixAndMergeSchema_1.default(schema, fixOptions);
            var extraMethods = null;
            // sprawdzenie options w schema
            if (schema2.$options) {
                if (schema2.$options.$methods) {
                    extraMethods = Object.assign(extraMethods || {}, schema2.$options.$methods);
                    schema2.$options.$methods = undefined;
                }
                IOptions_1.mergeOptions(soptions, schema2.$options);
            }
            if (schema2.$methods) {
                extraMethods = Object.assign(extraMethods || {}, schema2.$methods);
            }
            // sprawdzenie options
            if (sopts) {
                if (sopts.$methods) {
                    extraMethods = Object.assign(extraMethods || {}, sopts.$methods);
                    sopts.$methods = undefined;
                }
                IOptions_1.mergeOptions(soptions, sopts);
            }
            if (vm.$options.$methods) {
                extraMethods = Object.assign(extraMethods || {}, vm.$options.$methods);
            }
            if (extraMethods) {
                var areMethods = false;
                var _loop_1 = function (method) {
                    if (Object.prototype.hasOwnProperty.call(extraMethods, method)) {
                        var element_1 = extraMethods[method];
                        if (element_1 instanceof Function) {
                            // extraMethods[method] = element;
                            // ustawienie this na instancję vm
                            extraMethods[method] = function () { return element_1.apply(vm, arguments); };
                        }
                        else {
                            var methodText = element_1;
                            var methodsProps = '$0,$1,$2,$3,$4,$5,$6,$7,$8,$9';
                            var props = element_1.props || element_1.args;
                            var body = element_1.body || element_1.text;
                            if (props) {
                                methodsProps = props || '';
                            }
                            if (body) {
                                methodText = body;
                            }
                            if (Array.isArray(methodText)) {
                                methodText = methodText.join('\n');
                            }
                            extraMethods[method] = new Function(methodsProps, methodText);
                        }
                        areMethods = true;
                    }
                };
                for (var method in extraMethods) {
                    _loop_1(method);
                }
                if (areMethods) {
                    vm.$methods = soptions.Vue.prototype.$methods = soptions.schemaMethods = Object.assign({}, IOptions_1.defaultOptions.schemaMethods, extraMethods);
                    // vm.$methods = soptions.Vue.prototype.$methods = soptions.schemaMethods;
                }
            }
            if (process.env.NODE_ENV === 'development') {
                // tslint:disable-next-line: no-console
                console.timeEnd('schema fixing time');
            }
            var nfix = soptions.fixData;
            if (vm.model === null) {
                // tworzenie domyslnego
                if (nfix) {
                    vm.model = defaultValue_1.default(schema2, true);
                }
                else {
                    vm.model = {};
                }
            }
            else {
                if (nfix) {
                    if (process.env.NODE_ENV === 'development') {
                        // tslint:disable-next-line: no-console
                        console.time('fixData');
                    }
                    var fixed = fixData_1.default(schema2, vm.model, soptions.Vue);
                    if (process.env.NODE_ENV === 'development') {
                        // tslint:disable-next-line: no-console
                        console.timeEnd('fixData');
                        if (fixed) {
                            // tslint:disable-next-line: no-console
                            console.log('fixed fields: ' + fixed);
                        }
                    }
                }
            }
            // automatyczne wrapAll gdy model ma niej niż 100 elementów i nie było ustawiane
            if (!soptions.wrapAll &&
                (schema2.$options === undefined || schema2.$options.wrapAll === undefined) &&
                (!sopts || sopts.wrapAll === undefined) &&
                isModelSimple(vm.model, 100)) {
                soptions.wrapAll = true;
            }
            if (vm.$options.beforeSchema) {
                vm.$options.beforeSchema.call(vm, vm.model, schema2, soptions);
            }
            if (process.env.NODE_ENV === 'development') {
                // tslint:disable-next-line: no-console
                console.time('wrapping schema');
            }
            // tutaj extra methos z schema
            vm.$schema = new WrappedProperty_1.default[schema2.type](null, vm, 'model', schema2, soptions);
            Object.seal(vm.$schema);
            if (process.env.NODE_ENV === 'development') {
                // tslint:disable-next-line: no-console
                console.timeEnd('wrapping schema');
            }
            if (vm.$options.afterSchema) {
                vm.$options.afterSchema.call(vm, vm.$schema);
            }
            if (forceUpdate && vm.$forceUpdate) {
                vm.$forceUpdate();
            }
            return vm.$schema;
        }
    }
};
exports.default = schemaMixin;
//# sourceMappingURL=schemaMixin.js.map